import { CategoryData } from '../../../../types/types';

export const temps: CategoryData = {
    'sp': {
        translation: 'Fois, temps, occasion',
        translationEn: 'Time, occasion, instance',
        illustration: '𓊃𓊪𓊗',
        reading: 'Lecture analytique — sp (O34-Q3-O50), « fois, temps, occasion », forme réduite de spt, « aire de battage » (voir la fiche « spt » dans Plantes). C\'est ce même mot sp qui entre dans sp tpy, « la Première Occasion », le moment de la Création (voir la fiche « sp tpy » dans Divinités).',
        readingEn: 'Analytical reading — sp (O34-Q3-O50), "time, occasion, instance," a reduced form of spt, "threshing floor" (see the "spt" entry in Plants). This same word sp appears in sp tpy, "the First Occasion," the moment of Creation (see the "sp tpy" entry in Divinities).'
    },
    // Moments de la journée
    'dwꜣ': {
        translation: 'Matin / Aube – L\'heure du lever du soleil',
        translationEn: 'Morning / Dawn – The hour of sunrise',
        illustration: '𓇳𓇋',
    },
    'hrw': {
        translation: 'Jour – Le temps du soleil, de Rê',
        translationEn: 'Day – The time of the sun, of Ra',
        illustration: '𓉔𓅱𓇳',
        leadSign: 'N5',
        leadSignNote: 'N5 (disque solaire) sert seul, en écriture courte, à écrire hrw : pulaar hoore « tête » ; wolof xuuy « illuminer » ; bassa koyi « apparaître ».',
        reading: 'Lecture analytique — hrw (O4-G43-N5), « jour, journée » — graphie courte, le disque solaire N5 portant le sens. Pulaar hoore, « tête » — champ « tête / apparaître » qui rejoint le soleil qui se lève et illumine le jour.',
        readingEn: 'Analytical reading — hrw (O4-G43-N5), "day, daytime" — short spelling, the sun disk N5 carrying the meaning. Pulaar hoore, "head" — a "head / to appear" field that connects with the sun rising and lighting up the day.',
    },
    'mšrw': {
        translation: 'Soir / Crépuscule – Quand le soleil descend vers l\'Occident',
        translationEn: 'Evening / Dusk – When the sun descends toward the West',
        illustration: '𓇳𓅱',
    },
    'grḥ': {
        translation: 'Nuit – Le voyage de Rê dans le monde souterrain (Douat)',
        translationEn: 'Night – Ra\'s journey through the underworld (Duat)',
        illustration: '𓇸',
    },

    // Repères temporels
    'mjn': {
        translation: 'Aujourd\'hui',
        translationEn: 'Today',
        illustration: '𓇋𓈖𓈖',
    },
    'sf': {
        translation: 'Hier',
        translationEn: 'Yesterday',
        illustration: '𓋴𓆑',
    },
    'dwꜣ.t': {
        translation: 'Demain – Aussi nom de la Douat, monde de l\'au-delà',
        translationEn: 'Tomorrow – Also the name of the Duat, the world beyond',
        illustration: '𓂧𓅱𓄿𓏏𓇽',
        reading: 'Lecture analytique — dwꜣt (D46-G43-G1-X1-N15, dét. étoile-dans-cercle), « la Douat », monde souterrain/au-delà. Bamanan dá, « porte, entrée, issue » — la Douat conçue comme un seuil, un passage.',
        readingEn: 'Analytical reading — dwꜣt (D46-G43-G1-X1-N15, determinative: star-in-a-circle), "the Duat," the underworld/world beyond. Bamanan dá, "door, entrance, way out" — the Duat conceived as a threshold, a passage.'
    },

    // Unités de temps
    'wnw.t': {
        translation: 'Heure – Mesurée par les clepsydres et les cadrans solaires',
        translationEn: 'Hour – Measured by water clocks and sundials',
        illustration: '𓃹𓈖𓏌𓏏𓇼𓇳',
        leadSign: 'E34',
        leadSignNote: 'E34 (lièvre, valeur wn) : pulaar yonude « avoir le temps de faire quelque chose » ; yonnaade « punir en faisant payer » — voir aussi la fiche « wnty » dans Divinités.',
        reading: 'Lecture analytique — wnwt (E34-N35-W24-X1-N14-N5), « heure, service (sacerdotal), temps, moment », homophone de wnty (E34-X1-Z4-N14-N5), « le dieu Ounty, Horus-le-Triomphateur » (voir la fiche « wnty » dans Divinités). Pulaar yonude, « avoir le temps de faire quelque chose, être en fonction ».',
        readingEn: 'Analytical reading — wnwt (E34-N35-W24-X1-N14-N5), "hour, (priestly) service, time, moment," a homophone of wnty (E34-X1-Z4-N14-N5), "the god Wenty, Horus-the-Triumphant" (see the "wnty" entry in Divinities). Pulaar yonude, "to have time to do something, to be on duty."'
    },
    'ꜣbd': {
        translation: 'Mois / Lune – Divisé en 3 décades de 10 jours',
        translationEn: 'Month / Moon – Divided into 3 decades of 10 days',
        illustration: '𓆹',
    },
    'jꜥḥ': {
        translation: 'La lune (variante)',
        translationEn: 'The moon (variant)',
        illustration: '𓇋𓎛',
        reading: 'Lecture analytique — jꜥḥ (M17-V28-N12), « la lune », second mot égyptien pour la lune à côté de ꜣbd (voir la fiche « ꜣbd » ci-dessus). Homographe exact de jḥ, « bœuf, taureau » (voir la fiche « jḥ » dans Animaux) : seul le déterminatif distingue les deux mots. Copte ⲟⲟϩ, « lune ».',
        readingEn: 'Analytical reading — jꜥḥ (M17-V28-N12), "the moon," a second Egyptian word for the moon alongside ꜣbd (see the "ꜣbd" entry above). An exact homograph of jḥ, "ox, bull" (see the "jḥ" entry in Animals): only the determinative distinguishes the two words. Coptic ⲟⲟϩ, "moon."'
    },
    'rnp.t': {
        translation: 'Année – 365 jours divisés en trois saisons',
        translationEn: 'Year – 365 days divided into three seasons',
        illustration: '𓆳𓏏𓏤',
        leadSign: 'M4',
        leadSignNote: 'M4 (branche de palmier dépouillée), l\'instrument égyptien de décompte des années : copte ⲗⲁⲙⲡⲓ « année » ; kikongo -lombe « branche de palmier ».',
        reading: 'Lecture analytique — rnp.t (M4-X1-Z1), « année », homographe de rnp (D21-N35-Q3-E1), « jeune taureau » — même écriture pour « vache/génisse » et « année », jeu de mots repris par la tradition (les sept vaches du rêve de Pharaon interprétées comme sept années). Bemba ŋòmbè, « vache, bœuf ».',
        readingEn: 'Analytical reading — rnp.t (M4-X1-Z1), "year," a homograph of rnp (D21-N35-Q3-E1), "young bull" — the same spelling for "cow/heifer" and "year," a wordplay taken up by tradition (the seven cows in Pharaoh\'s dream interpreted as seven years). Bemba ŋòmbè, "cow, ox."'
    },

    // Les trois saisons du calendrier égyptien
    'ꜣḫ.t': {
        translation: 'Akhet – Saison de l\'Inondation (juin–octobre) : le Nil déborde et fertilise la terre',
        translationEn: 'Akhet – The Inundation season (June–October): the Nile floods and fertilizes the land',
        illustration: '𓄿𓆷𓐍𓏏',
        reading: 'Lecture analytique — ꜣḫt (G1-M8-Aa1-X1), « saison de l\'inondation ». Lecture réelle rapprochée *aka, comparée au proto-bantou *-áka, « année » : swahili mwaka, « année ».',
        readingEn: 'Analytical reading — ꜣḫt (G1-M8-Aa1-X1), "flood season." A reconstructed real reading close to *aka, compared to Proto-Bantu *-áka, "year": Swahili mwaka, "year."'
    },
    'pr.t': {
        translation: 'Péret – Saison des Semailles (octobre–février) : la terre émerge et l\'on plante',
        translationEn: 'Peret – The Emergence/Sowing season (October–February): the land emerges and planting begins',
        illustration: '𓉐𓂋𓏏𓇳',
        leadSign: 'O1',
        leadSignNote: 'O1 (maison, valeur pr) : copte ⲡⲉⲓⲣⲉ « apparaître » ; fang ber/bere « monter » ; bassa ɓér « monter ».',
        reading: 'Lecture analytique — pr.t (O1-D21-X1-N5), « saison de la germination, hiver », homographe de prt (O1-D21-X1-D54), « sortie » — même mot, deux déterminatifs : le soleil N5 pour la saison, les jambes en marche D54 pour l\'action de « sortir ». Cohérent avec Péret, saison où les jeunes pousses sortent de terre après la décrue. Copte ⲡⲉⲓⲣⲉ, « apparaître ».',
        readingEn: 'Analytical reading — pr.t (O1-D21-X1-N5), "germination season, winter," a homograph of prt (O1-D21-X1-D54), "going out" — the same word, two determinatives: the sun N5 for the season, the walking legs D54 for the action of "going out." Consistent with Peret, the season when young shoots emerge from the ground after the floodwaters recede. Coptic ⲡⲉⲓⲣⲉ, "to appear."'
    },
    'šmw': {
        translation: 'Shemou – Saison des Moissons (février–juin) : on récolte avant la nouvelle crue',
        translationEn: 'Shemu – The Harvest season (February–June): crops are gathered before the next flood',
        illustration: '𓈙𓈗𓇳',
        leadSign: 'N37',
        leadSignNote: 'N37 (bassin d\'eau, valeur š), le même signe que šrt/dšr : descendant copte direct ϣⲱⲙ « été, moisson ».',
        reading: 'Lecture analytique — šmw (N37-N35A-N5), « moisson, récolte », puis « saison de la moisson » — descendant copte direct ϣⲱⲙ / šame, « été, moisson ». Proche par la forme du nom Swth, variante attestée de Seth, cohérent avec Seth comme dieu associé à la chaleur de cette saison. Swahili sehemu, « part, portion, segment » (la récolte comme ce qui est prélevé/partagé).',
        readingEn: 'Analytical reading — šmw (N37-N35A-N5), "harvest, crop," then "harvest season" — direct Coptic descendant ϣⲱⲙ / šame, "summer, harvest." Close in form to the name Swth, an attested variant of Seth, consistent with Seth as the god associated with the heat of this season. Swahili sehemu, "part, portion, segment" (the harvest as that which is taken/shared out).'
    }
};

export default temps;
